var _style, _path, _path2, _path3, _path4, _polygon, _polygon2, _polygon3, _polygon4, _rect, _polygon5, _polygon6, _polygon7, _path5, _path6, _polygon8, _polygon9, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    viewBox: "0 180.11 512.01 151.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A6A6A6;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:url(#XMLID_00000074399482610963359890000010792147823077505450_);}\n\t.st3{fill:url(#XMLID_00000052811187043122028380000001811314322265777033_);}\n\t.st4{fill:url(#XMLID_00000139277537561388697480000016912290513276675755_);}\n\t.st5{fill:url(#XMLID_00000063627320379406487300000012519886909615782274_);}\n\t.st6{fill:url(#XMLID_00000060718412196240000050000011049211296027238588_);}\n\t.st7{fill:url(#XMLID_00000183238528855106703540000007353090720197446079_);}\n\t.st8{fill:url(#XMLID_00000072255918856759468950000011454658302132431505_);}\n\t.st9{fill:url(#XMLID_00000181775991963827306600000007780348089024877232_);}\n\t.st10{fill:url(#XMLID_00000077294483074697731400000012099702801281752202_);}\n\t.st11{fill:#404040;}\n\t.st12{fill:url(#XMLID_00000067947370892173767350000000123217439097245887_);}\n\t.st13{fill:url(#XMLID_00000115485130720055384200000010586769129684497028_);}\n\t.st14{fill:url(#XMLID_00000065760453294633824470000016338208264226016957_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_15_"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M493.06,331.89H18.94C8.56,331.89,0,323.33,0,312.95V199.19c0-10.38,8.56-18.94,18.94-18.94h474.13   c10.38,0,18.94,8.56,18.94,18.94v113.76C512,323.33,503.44,331.89,493.06,331.89"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    className: "st0",
    d: "M493.06,183.2c8.84,0,15.99,7.15,15.99,15.99v113.76c0,8.84-7.15,15.99-15.99,15.99H18.94   c-8.84,0-15.99-7.15-15.99-15.99V199.19c0-8.84,7.15-15.99,15.99-15.99H493.06 M493.06,180.11H18.94C8.56,180.11,0,188.67,0,199.05   v113.76c0,10.38,8.56,18.94,18.94,18.94h474.13c10.38,0,18.94-8.56,18.94-18.94V199.05C512,188.67,503.44,180.11,493.06,180.11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    className: "st1",
    d: "M179.83,218.97c0,3.23-0.98,5.75-2.81,7.57c-2.1,2.24-4.91,3.37-8.42,3.37   c-3.23,0-6.03-1.12-8.42-3.37c-2.24-2.24-3.51-5.05-3.51-8.42c0-3.37,1.12-6.17,3.51-8.42c2.24-2.24,5.05-3.37,8.42-3.37   c1.68,0,3.23,0.28,4.63,0.98c1.54,0.7,2.67,1.54,3.51,2.52l-1.96,1.96c-1.54-1.82-3.65-2.67-6.17-2.67c-2.38,0-4.49,0.84-6.17,2.52   c-1.68,1.68-2.67,3.93-2.67,6.59s0.84,4.91,2.67,6.59c1.68,1.68,3.79,2.52,6.17,2.52c2.52,0,4.63-0.84,6.31-2.52   c1.12-1.12,1.68-2.67,1.96-4.63h-8.28v-2.67h11.08C179.83,217.85,179.83,218.41,179.83,218.97z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st1",
    d: "M179.83,218.97L179.83,218.97c-0.14,3.09-1.12,5.61-2.95,7.43l0,0l0,0   c-2.1,2.24-4.91,3.37-8.28,3.37c-3.23,0-6.03-1.12-8.28-3.37c-2.24-2.24-3.37-5.05-3.37-8.42c0-3.37,1.12-6.17,3.37-8.42   c2.24-2.24,5.05-3.37,8.28-3.37c1.54,0,3.09,0.28,4.63,0.98c1.4,0.56,2.67,1.4,3.51,2.52l0.14-0.14l-0.14-0.14l-1.96,1.96   l0.14,0.14l0.14-0.14c-1.54-1.82-3.65-2.81-6.31-2.81c-2.38,0-4.49,0.84-6.31,2.52c-1.82,1.68-2.67,3.93-2.67,6.73   c0,2.67,0.84,4.91,2.67,6.73c1.82,1.68,3.93,2.52,6.31,2.52c2.52,0,4.77-0.84,6.45-2.52c1.12-1.12,1.82-2.67,1.96-4.63v-0.14h-8.28   v-2.38h10.94v-0.14h-0.14C179.69,217.85,179.69,218.41,179.83,218.97L179.83,218.97h0.14c0-0.56,0-1.12-0.14-1.68v-0.14h-11.22   v2.95h8.42v-0.14h-0.14c-0.14,1.96-0.84,3.51-1.82,4.49c-1.68,1.68-3.79,2.52-6.31,2.52c-2.38,0-4.35-0.84-6.17-2.52   c-1.68-1.68-2.52-3.79-2.52-6.45c0-2.67,0.84-4.77,2.52-6.45c1.68-1.68,3.79-2.52,6.17-2.52c2.67,0,4.63,0.84,6.17,2.67l0.14,0.14   l2.24-2.24l-0.14-0.14c-0.84-1.12-2.1-1.96-3.65-2.52c-1.54-0.7-3.09-0.98-4.77-0.98c-3.37,0-6.17,1.12-8.42,3.51   c-2.38,2.24-3.51,5.19-3.51,8.56c0,3.37,1.12,6.31,3.51,8.56c2.38,2.24,5.19,3.51,8.42,3.51c3.51,0,6.31-1.12,8.42-3.37l-0.14-0.14   l0.14,0.14C179.13,224.72,179.97,222.19,179.83,218.97L179.83,218.97L179.83,218.97z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_26_",
    className: "st1",
    points: "197.37,209.43 186.99,209.43 186.99,216.72 196.24,216.72 196.24,219.39    186.99,219.39 186.99,226.68 197.37,226.68 197.37,229.49 184.04,229.49 184.04,206.76 197.37,206.76  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_27_",
    className: "st1",
    points: "197.37,209.43 197.37,209.29 186.84,209.29 186.84,216.86 196.1,216.86 196.1,219.25    186.84,219.25 186.84,226.82 197.23,226.82 197.23,229.35 184.18,229.35 184.18,206.9 197.23,206.9 197.23,209.43 197.37,209.43    197.37,209.29 197.37,209.43 197.51,209.43 197.51,206.62 183.9,206.62 183.9,229.63 197.51,229.63 197.51,226.54 187.13,226.54    187.13,219.53 196.38,219.53 196.38,216.58 187.13,216.58 187.13,209.57 197.51,209.57 197.51,209.43  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_28_",
    className: "st1",
    points: "209.71,229.49 206.76,229.49 206.76,209.43 200.31,209.43 200.31,206.76    216.02,206.76 216.02,209.43 209.71,209.43  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_29_",
    className: "st1",
    points: "209.71,229.49 209.71,229.35 206.9,229.35 206.9,209.29 200.45,209.29 200.45,206.9    215.88,206.9 215.88,209.29 209.57,209.29 209.57,229.49 209.71,229.49 209.71,229.35 209.71,229.49 209.85,229.49 209.85,209.57    216.16,209.57 216.16,206.62 200.17,206.62 200.17,209.57 206.62,209.57 206.62,229.63 209.85,229.63 209.85,229.49  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: 227.38,
    y: 206.76,
    className: "st1",
    width: 2.95,
    height: 22.72
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_32_",
    className: "st1",
    points: "227.38,229.49 227.52,229.49 227.52,206.9 230.05,206.9 230.05,229.35 227.38,229.35    227.38,229.49 227.52,229.49 227.38,229.49 227.38,229.63 230.33,229.63 230.33,206.62 227.24,206.62 227.24,229.63 227.38,229.63     "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_33_",
    className: "st1",
    points: "243.24,229.49 240.29,229.49 240.29,209.43 233.98,209.43 233.98,206.76    249.55,206.76 249.55,209.43 243.24,209.43  "
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_34_",
    className: "st1",
    points: "243.24,229.49 243.24,229.35 240.43,229.35 240.43,209.29 234.12,209.29 234.12,206.9    249.41,206.9 249.41,209.29 243.09,209.29 243.09,229.49 243.24,229.49 243.24,229.35 243.24,229.49 243.38,229.49 243.38,209.57    249.69,209.57 249.69,206.62 233.84,206.62 233.84,209.57 240.15,209.57 240.15,229.63 243.38,229.63 243.38,229.49  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st1",
    d: "M279.15,226.54c-2.24,2.24-5.05,3.51-8.28,3.51c-3.37,0-6.17-1.12-8.28-3.51   c-2.24-2.24-3.37-5.05-3.37-8.42c0-3.37,1.12-6.17,3.37-8.42c2.24-2.24,5.05-3.51,8.28-3.51c3.37,0,6.03,1.12,8.28,3.51   c2.24,2.24,3.37,5.05,3.37,8.42C282.51,221.35,281.39,224.16,279.15,226.54z M264.7,224.58c1.68,1.68,3.79,2.52,6.17,2.52   c2.38,0,4.49-0.84,6.17-2.52c1.68-1.68,2.52-3.93,2.52-6.59c0-2.67-0.84-4.77-2.52-6.59c-1.68-1.68-3.79-2.52-6.17-2.52   c-2.38,0-4.49,0.84-6.17,2.52c-1.68,1.68-2.52,3.93-2.52,6.59C262.17,220.65,263.01,222.9,264.7,224.58z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_47_",
    className: "st1",
    d: "M279.15,226.54L279.15,226.54c-2.24,2.24-5.05,3.37-8.28,3.37s-6.03-1.12-8.28-3.37   c-2.24-2.24-3.37-5.05-3.37-8.28c0-3.23,1.12-6.03,3.37-8.28c2.24-2.24,4.91-3.37,8.28-3.37c3.23,0,6.03,1.12,8.28,3.37   c2.24,2.24,3.37,5.05,3.37,8.28C282.37,221.35,281.25,224.16,279.15,226.54L279.15,226.54L279.15,226.54   c2.38-2.24,3.51-5.05,3.51-8.42c0-3.37-1.12-6.17-3.37-8.56c-2.24-2.38-5.05-3.51-8.42-3.51s-6.17,1.12-8.42,3.51   s-3.37,5.19-3.37,8.56s1.12,6.17,3.37,8.56c2.24,2.38,5.05,3.51,8.42,3.51C274.24,230.05,277.04,228.93,279.15,226.54   L279.15,226.54z M264.7,224.58L264.7,224.58c1.54,1.82,3.65,2.67,6.17,2.67c2.52,0,4.63-0.84,6.31-2.67   c1.68-1.68,2.52-3.93,2.52-6.59c0-2.67-0.84-4.91-2.52-6.59c-1.68-1.68-3.79-2.67-6.31-2.67s-4.63,0.84-6.31,2.67   c-1.68,1.68-2.52,3.93-2.52,6.59C262.03,220.79,262.87,223.04,264.7,224.58L264.7,224.58L264.7,224.58   c-1.54-1.82-2.38-3.93-2.38-6.59c0-2.67,0.84-4.77,2.52-6.45c1.68-1.68,3.65-2.52,6.03-2.52s4.49,0.84,6.03,2.52   c1.68,1.68,2.52,3.79,2.52,6.45c0,2.67-0.84,4.77-2.52,6.45c-1.68,1.68-3.65,2.52-6.03,2.52   C268.48,226.96,266.38,226.12,264.7,224.58L264.7,224.58z"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_48_",
    className: "st1",
    points: "286.58,229.49 286.58,206.76 290.23,206.76 301.31,224.44 301.31,224.44    301.31,219.95 301.31,206.76 304.11,206.76 304.11,229.49 301.17,229.49 289.53,210.83 289.39,210.83 289.53,215.32 289.53,229.49     "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_49_",
    className: "st1",
    points: "286.58,229.49 286.72,229.49 286.72,206.9 290.09,206.9 301.17,224.58 301.31,224.58    301.45,224.58 301.45,219.95 301.45,206.9 303.97,206.9 303.97,229.35 301.17,229.35 289.67,210.69 289.39,210.69 289.24,210.69    289.39,215.32 289.39,229.35 286.58,229.35 286.58,229.49 286.72,229.49 286.58,229.49 286.58,229.63 289.67,229.63 289.67,215.32    289.53,210.83 289.39,210.83 289.39,210.97 289.53,210.97 301.03,229.63 304.25,229.63 304.25,206.62 301.17,206.62 301.17,219.95    301.17,224.44 301.31,224.44 301.31,224.3 301.31,224.3 290.23,206.62 286.44,206.62 286.44,229.63 286.58,229.63  "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_131_",
    className: "st1",
    d: "M258.38,262.59c-8.98,0-16.13,6.73-16.13,16.13c0,9.26,7.29,16.13,16.13,16.13   c8.98,0,16.13-6.87,16.13-16.13C274.66,269.47,267.36,262.59,258.38,262.59z M258.38,288.54c-4.91,0-9.12-4.07-9.12-9.82   s4.21-9.82,9.12-9.82c4.91,0,9.12,3.93,9.12,9.82C267.5,284.48,263.29,288.54,258.38,288.54z M223.04,262.59   c-8.98,0-16.13,6.73-16.13,16.13c0,9.26,7.29,16.13,16.13,16.13c8.98,0,16.13-6.87,16.13-16.13   C239.31,269.47,232.01,262.59,223.04,262.59z M223.04,288.54c-4.91,0-9.12-4.07-9.12-9.82s4.21-9.82,9.12-9.82s9.12,3.93,9.12,9.82   C232.15,284.48,227.95,288.54,223.04,288.54z M181.09,267.64v6.87h16.41c-0.42,3.79-1.82,6.59-3.79,8.56   c-2.38,2.38-6.17,5.05-12.62,5.05c-10.1,0-17.96-8.14-17.96-18.24s7.86-18.24,17.96-18.24c5.47,0,9.4,2.1,12.34,4.91l4.77-4.77   c-4.07-3.93-9.54-6.87-17.11-6.87c-13.75,0-25.39,11.22-25.39,25.11c0,13.75,11.64,25.11,25.39,25.11c7.43,0,13.05-2.38,17.53-7.01   c4.49-4.49,5.89-10.94,5.89-15.99c0-1.54-0.14-3.09-0.42-4.21h-23V267.64z M352.93,272.97c-1.4-3.65-5.47-10.24-13.75-10.24   c-8.28,0-15.15,6.59-15.15,16.13c0,8.98,6.87,16.13,15.99,16.13c7.43,0,11.64-4.49,13.47-7.15l-5.47-3.65   c-1.82,2.67-4.35,4.49-8,4.49s-6.17-1.68-7.86-4.91l21.6-8.98L352.93,272.97z M330.91,278.3c-0.14-6.17,4.77-9.4,8.42-9.4   c2.81,0,5.19,1.4,6.03,3.37L330.91,278.3z M313.37,293.87h7.15v-47.41h-7.15V293.87z M301.73,266.24h-0.28   c-1.54-1.96-4.63-3.65-8.56-3.65c-8,0-15.43,7.15-15.43,16.13c0,8.98,7.43,16.13,15.43,16.13c3.79,0,6.87-1.68,8.56-3.65h0.28v2.38   c0,6.17-3.37,9.54-8.56,9.54c-4.35,0-7.01-3.09-8.14-5.75l-6.17,2.52c1.82,4.21,6.45,9.54,14.31,9.54   c8.28,0,15.29-4.91,15.29-16.83v-28.9h-6.73V266.24L301.73,266.24z M293.59,288.54c-4.91,0-8.98-4.07-8.98-9.68   c0-5.75,4.07-9.82,8.98-9.82c4.77,0,8.56,4.21,8.56,9.82C302.29,284.48,298.5,288.54,293.59,288.54z M386.17,246.46H369.2v47.41   h7.01v-17.96h9.82c7.86,0,15.57-5.61,15.57-14.73C401.6,252.21,393.89,246.46,386.17,246.46z M386.31,269.33h-10.1v-16.27h10.1   c5.33,0,8.28,4.35,8.28,8.14C394.59,264.98,391.64,269.33,386.31,269.33z M430.08,262.59c-5.19,0-10.38,2.24-12.62,7.29l6.31,2.67   c1.4-2.67,3.79-3.51,6.45-3.51c3.65,0,7.43,2.24,7.43,6.03v0.42c-1.26-0.7-4.07-1.82-7.43-1.82c-6.73,0-13.61,3.79-13.61,10.66   c0,6.31,5.61,10.38,11.78,10.38c4.77,0,7.43-2.1,8.98-4.63h0.28v3.65h6.87V275.5C444.39,267.22,438.08,262.59,430.08,262.59z    M429.24,288.54c-2.38,0-5.61-1.12-5.61-4.07c0-3.65,4.07-5.05,7.43-5.05c3.09,0,4.63,0.7,6.45,1.54   C437.09,285.46,433.31,288.54,429.24,288.54z M469.36,263.57l-8.14,20.62h-0.28l-8.42-20.62h-7.57l12.62,28.76l-7.15,15.99h7.43   l19.5-44.75H469.36L469.36,263.57z M405.53,293.87h7.01v-47.41h-7.01V293.87z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000127019355819888829300000012370110750159697797_",
    gradientUnits: "userSpaceOnUse",
    x1: -959.6257,
    y1: 2.6227,
    x2: -958.223,
    y2: 2.6227,
    gradientTransform: "matrix(-45.3747 45.3747 45.3747 45.3747 -43579.0312 43636.9297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#00A1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00BEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00D2FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00DFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00E3FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_135_",
    style: {
      fill: "url(#XMLID_00000127019355819888829300000012370110750159697797_)"
    },
    d: "M37.87,213.36   L37.87,213.36L37.87,213.36 M37.87,213.36L37.87,213.36L37.87,213.36 M39.84,209.01c-1.26,1.12-1.96,3.09-1.96,5.61v-0.56   c0-0.28,0-0.42,0-0.7c0,0.28,0,0.42,0,0.7v83.88v-0.56c0,2.38,0.7,4.21,1.82,5.33l0.28,0.28L86.97,256L39.84,209.01"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000031181392453770396390000004971261263270704521_",
    gradientUnits: "userSpaceOnUse",
    x1: -964.0526,
    y1: -7.0364,
    x2: -962.6498,
    y2: -7.0364,
    gradientTransform: "matrix(-65.4213 0 0 65.4213 -62941.2617 716.5425)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFBD00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFA500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9C00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_138_",
    style: {
      fill: "url(#XMLID_00000031181392453770396390000004971261263270704521_)"
    },
    d: "M124.84,258.24   c-0.56,1.26-1.82,2.38-3.37,3.23l-18.52,10.52l-0.42,0.14l0,0l0.42-0.14l18.52-10.52C123.02,260.49,124.28,259.37,124.84,258.24    M102.54,240.29L86.83,256l15.71,15.71l18.94-10.8c2.38-1.4,3.79-3.09,3.93-4.91l0,0c-0.28-1.82-1.54-3.51-3.93-4.91L102.54,240.29   "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000174581711005091050070000010796619719633794965_",
    gradientUnits: "userSpaceOnUse",
    x1: -957.0048,
    y1: 0.0526,
    x2: -955.6021,
    y2: 0.0526,
    gradientTransform: "matrix(-61.5316 61.5316 61.5316 61.5316 -58795.1016 59147.5234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF3A44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C31162"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_142_",
    style: {
      fill: "url(#XMLID_00000174581711005091050070000010796619719633794965_)"
    },
    d: "M39.84,303.55   L39.84,303.55c0.84,0.84,2.1,1.26,3.37,1.26c0.28,0,0.42,0,0.7,0c-0.28,0-0.42,0-0.7,0C41.94,304.82,40.82,304.39,39.84,303.55    M39.56,303.27l0.28,0.28L39.56,303.27 M86.83,256L86.83,256l-46.99,46.99l0,0l-0.28,0.28l0.28-0.28c0.84,0.84,2.1,1.26,3.37,1.26   c1.26,0,2.67-0.42,4.21-1.26l54.99-31.28l0.42,0.42l-0.42-0.42L86.83,256"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000043458403970144941130000011787101746002082463_",
    gradientUnits: "userSpaceOnUse",
    x1: -933.3701,
    y1: 8.0539,
    x2: -931.9673,
    y2: 8.0539,
    gradientTransform: "matrix(27.4765 27.4765 27.4765 -27.4765 25452.1445 26047.8359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#32A071"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#2DA771"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#15CF74"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#06E775"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00F076"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_145_",
    style: {
      fill: "url(#XMLID_00000043458403970144941130000011787101746002082463_)"
    },
    d: "M43.2,207.75   c-1.26,0-2.52,0.42-3.37,1.26L86.83,256l15.71-15.71l-54.99-31.28C45.87,208.17,44.47,207.75,43.2,207.75 M43.2,207.18L43.2,207.18   L43.2,207.18c1.26,0,2.67,0.42,4.21,1.26l55.41,31.42l0,0l-55.41-31.42C45.87,207.61,44.47,207.18,43.2,207.18"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_159_",
    d: "M39.84,303.55L39.84,303.55L39.84,303.55L39.84,303.55 M47.41,303.55c-1.26,0.7-2.52,1.12-3.65,1.26   C45.03,304.68,46.15,304.25,47.41,303.55 M39.56,303.27L39.56,303.27L39.56,303.27L39.56,303.27"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000009563299896215907790000009205409277229851281_",
    gradientUnits: "userSpaceOnUse",
    x1: -957.0048,
    y1: 0.0543,
    x2: -955.6021,
    y2: 0.0543,
    gradientTransform: "matrix(-61.5316 61.5316 61.5316 61.5316 -58795.1016 59147.5234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CC2E36"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9C0E4E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_160_",
    style: {
      fill: "url(#XMLID_00000009563299896215907790000009205409277229851281_)"
    },
    d: "M102.54,271.71   l-54.99,31.28c-1.54,0.84-2.95,1.26-4.21,1.26c-1.26,0-2.52-0.42-3.37-1.26l-0.28,0.28l0,0l0.28,0.28l0,0l0,0   c0.84,0.84,2.1,1.26,3.37,1.26c0.28,0,0.42,0,0.7,0c1.12-0.14,2.38-0.56,3.65-1.26l55.41-31.42L102.54,271.71"
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_161_",
    d: "M37.87,297.94L37.87,297.94c0,2.38,0.7,4.21,1.82,5.33l0,0l0,0l0,0   C38.44,302.15,37.87,300.33,37.87,297.94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000181068212099119805600000001971856061801694125_",
    gradientUnits: "userSpaceOnUse",
    x1: -959.6257,
    y1: 2.7596,
    x2: -958.2229,
    y2: 2.7596,
    gradientTransform: "matrix(-45.3749 45.3749 45.3749 45.3749 -43563.832 43652.5156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#008DE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#008DE0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#00A7E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#00B8E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#00C4E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00C7E0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_162_",
    style: {
      fill: "url(#XMLID_00000181068212099119805600000001971856061801694125_)"
    },
    d: "M37.87,297.38v0.56   c0,2.38,0.7,4.21,1.82,5.33l0.28-0.28l-0.28-0.28C38.44,301.59,37.87,299.77,37.87,297.38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000010992998990558257440000009696433222934017211_",
    gradientUnits: "userSpaceOnUse",
    x1: -957.0049,
    y1: 0.015,
    x2: -955.6022,
    y2: 0.015,
    gradientTransform: "matrix(-61.5299 61.5299 61.5299 61.5299 -58799.207 59140.1875)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0333C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB0F56"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_163_",
    style: {
      fill: "url(#XMLID_00000010992998990558257440000009696433222934017211_)"
    },
    points: "39.84,302.99    39.56,303.27 39.56,303.27 39.84,302.99 39.84,302.99  "
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_164_",
    d: "M125.4,256L125.4,256c0,0.7-0.14,1.54-0.56,2.24C125.26,257.54,125.4,256.7,125.4,256"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000168828136157907252510000003752885772708384170_",
    gradientUnits: "userSpaceOnUse",
    x1: -964.0526,
    y1: -7.0006,
    x2: -962.6499,
    y2: -7.0006,
    gradientTransform: "matrix(-65.4212 0 0 65.4212 -62941.168 722.0545)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0C500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#E0A600"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#E09100"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E08900"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_165_",
    style: {
      fill: "url(#XMLID_00000168828136157907252510000003752885772708384170_)"
    },
    d: "M125.4,256   c-0.28,1.82-1.54,3.51-3.93,4.91l-18.94,10.8l0.42,0.42l18.52-10.52c1.68-0.98,2.81-2.1,3.37-3.23   C125.26,257.54,125.4,256.7,125.4,256"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000113340076249915323440000003700555396127666096_",
    gradientUnits: "userSpaceOnUse",
    x1: -94.6849,
    y1: 271.851,
    x2: -93.2822,
    y2: 271.851,
    gradientTransform: "matrix(-9.999997e-05 9.999997e-05 9.999997e-05 9.999997e-05 -809.3907 222.3929)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E0333C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AB0F56"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_166_",
    style: {
      fill: "url(#XMLID_00000113340076249915323440000003700555396127666096_)"
    },
    points: "102.54,271.71    102.54,271.71 102.82,271.99 102.54,271.71  "
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_171_",
    className: "st11",
    d: "M102.82,240.01L102.82,240.01L102.82,240.01l18.52,10.52c2.67,1.54,3.93,3.51,3.93,5.47l0,0   c0-1.96-1.26-3.93-3.93-5.47L102.82,240.01 M37.87,213.36L37.87,213.36L37.87,213.36 M37.87,213.36L37.87,213.36L37.87,213.36    M43.2,207.18c-2.95,0-5.05,2.24-5.33,6.17c0.14-1.96,0.7-3.51,1.68-4.63l0.28-0.28l0,0C40.68,207.61,41.94,207.18,43.2,207.18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000169552287556302257940000003964205949767284096_",
    gradientUnits: "userSpaceOnUse",
    x1: -959.6257,
    y1: 2.4783,
    x2: -958.2229,
    y2: 2.4783,
    gradientTransform: "matrix(-45.3749 45.3749 45.3749 45.3749 -43595.4336 43620.9141)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40B8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    style: {
      stopColor: "#40B9FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    style: {
      stopColor: "#40CEFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#40DDFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    style: {
      stopColor: "#40E7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40EAFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_174_",
    style: {
      fill: "url(#XMLID_00000169552287556302257940000003964205949767284096_)"
    },
    d: "M39.56,208.73   L39.56,208.73c-0.98,0.98-1.54,2.67-1.68,4.63l0,0l0,0l0,0l0,0c0,0.28,0,0.42,0,0.7v0.56c0-2.52,0.7-4.49,1.96-5.61L39.56,208.73    M39.84,208.45L39.84,208.45L39.84,208.45L39.84,208.45"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000097464601602351478790000012932751611145761977_",
    gradientUnits: "userSpaceOnUse",
    x1: -964.0526,
    y1: -7.0705,
    x2: -962.6498,
    y2: -7.0705,
    gradientTransform: "matrix(-65.4215 0 0 65.4215 -62941.4453 710.6357)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFE840"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    style: {
      stopColor: "#FFCE40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    style: {
      stopColor: "#FFBC40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFB540"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    style: {
      fill: "url(#XMLID_00000097464601602351478790000012932751611145761977_)"
    },
    d: "M102.82,240.01   l-0.42,0.42l18.94,10.8c2.38,1.4,3.79,3.09,3.93,4.91c0-1.96-1.26-3.93-3.93-5.47L102.82,240.01L102.82,240.01"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "XMLID_00000060018631681971468740000006475995419993642632_",
    gradientUnits: "userSpaceOnUse",
    x1: -933.3701,
    y1: 8.0539,
    x2: -931.9673,
    y2: 8.0539,
    gradientTransform: "matrix(27.4765 27.4765 27.4765 -27.4765 25452.1445 26047.8359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#65B895"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    style: {
      stopColor: "#62BD95"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    style: {
      stopColor: "#50DB97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    style: {
      stopColor: "#44ED98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40F498"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_176_",
    style: {
      fill: "url(#XMLID_00000060018631681971468740000006475995419993642632_)"
    },
    d: "M43.2,207.18L43.2,207.18   c-1.26,0-2.52,0.42-3.37,1.26l0,0l-0.28,0.28l0.28,0.28c0.84-0.84,2.1-1.26,3.37-1.26c1.26,0,2.67,0.42,4.21,1.26l54.99,31.28   l0.42-0.42l0,0l-55.41-31.42C45.87,207.61,44.47,207.18,43.2,207.18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPlaystore);
export default __webpack_public_path__ + "static/media/downloadPlaystore.84c4d261ffd5f19f7cf4ee4e668698d3.svg";
export { ForwardRef as ReactComponent };